import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { ArtistPage, ArtistProfile } from '@/api/types'

export function useArtist(path: string) {
  return useQuery({
    queryKey: ['artists', path],
    queryFn: ({ signal }) => api.get<ArtistProfile>(path, {}, signal),
    staleTime: 60_000,
  })
}

export function useArtistContent<T>(path: string, section: 'songs' | 'albums', enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ['artists', path, section],
    queryFn: ({ signal, pageParam }) =>
      api.get<ArtistPage<T>>(path, { section, offset: pageParam }, signal),
    initialPageParam: 0,
    getNextPageParam: (page) => page.next_offset ?? undefined,
    enabled,
    staleTime: 60_000,
  })
}
